import { render, staticRenderFns } from "./MyNCFList.vue?vue&type=template&id=37dc5968&scoped=true&"
import script from "./MyNCFList.vue?vue&type=script&lang=js&"
export * from "./MyNCFList.vue?vue&type=script&lang=js&"
import style0 from "./MyNCFList.vue?vue&type=style&index=0&id=37dc5968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dc5968",
  null
  
)

export default component.exports